module.exports = __webpack_public_path__ + "static/media/9_bsp.71e43325.mp3";